import React, { useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { T } from "services/lang/LanguageService";
import { InputSwitch } from "primereact/inputswitch";
import { ButtonType, TaskTriggerButtonProps } from "../TaskTriggerButtonTypes";
import { buttonTypeOptions, defaultConfig } from "../taskTriggerButtonConstants";

const TaskTriggerButtonEditor = ({
  config,
  onConfigChange,
}: DashboardEditorProps<TaskTriggerButtonProps>) => {
  useEffect(() => {
    if (config && !Object.keys(config).length) {
      onConfigChange(defaultConfig);
    }
  }, []);

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="dagId">DAG ID</label>
          <InputText
            id="dagId"
            value={config.dagId ?? ""}
            onChange={e => onConfigChange({ ...config, dagId: e.target.value })}
          />
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="taskId">{T("word.task-id")}</label>
          <InputText
            id="taskId"
            value={config.taskId ?? ""}
            onChange={e => onConfigChange({ ...config, taskId: e.target.value })}
          />
        </div>
        <div className="flex flex-column gap-2 w-3">
          <label htmlFor="buttonType">{T("word.button-type")}</label>
          <Dropdown
            id="buttonType"
            value={config.buttonType ?? ButtonType.LABEL_AND_ICON}
            options={buttonTypeOptions}
            onChange={e => onConfigChange({ ...config, buttonType: e.value })}
          />
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="useTooltip">{T("word.use-tooltip")}</label>
          <InputSwitch
            id="useTooltip"
            checked={config.useTooltip ?? false}
            onChange={e => onConfigChange({ ...config, useTooltip: e.value })}
          />
        </div>
      </div>
      <Divider />
      <div className="flex flex-row gap-3">
        {config.buttonType !== ButtonType.ICON_ONLY && (
          <div className="flex flex-column gap-2 w-2">
            <label htmlFor="label">{T("word.label")}</label>
            <InputText
              id="label"
              value={config.label}
              onChange={e => onConfigChange({ ...config, label: e.target.value })}
            />
          </div>
        )}
        {config.buttonType !== ButtonType.LABEL_ONLY && (
          <div className="flex flex-column gap-2 w-2">
            <label htmlFor="icon">{T("word.icon")}</label>
            <InputText
              id="icon"
              value={config.icon}
              onChange={e => onConfigChange({ ...config, icon: e.target.value })}
            />
          </div>
        )}
        {config.useTooltip && (
          <div className="flex flex-column gap-2 w-3">
            <label htmlFor="tooltip">{T("word.tooltip")}</label>
            <InputText
              id="tooltip"
              value={config.tooltip}
              onChange={e => onConfigChange({ ...config, tooltip: e.target.value })}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskTriggerButtonEditor;
